// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/fr"
import AnalyticsProducts from "src/components/pages/AnalyticsProducts/AnalyticsProducts"

const AnalyticsProductsPageFr = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `analyticsProductsPage.sections`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.analyticsProductsPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <AnalyticsProducts sections={sections} />
    </Layout>
  )
}

export default AnalyticsProductsPageFr

export const query = graphql`
  query AnalyticsProductsPageFrQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "fr" }) {
      ...topNavContent
    }

    analyticsProductsPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    bottomNav: strapiBottomNav(locale: { eq: "fr" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
